import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import MDButton from "../../MDButton";
import { CircularProgress } from "@mui/material";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { storeDriver } from "../../../actions/driver/driver";
import ModalSelectDestination from "../../Modal/Destination/DestinationSelectModal";
import ModalSelectJens from "../../Modal/Jens/JensSelectModal";
import ModalSelectLocation from "../../Modal/Locations/LocationSelectModal";
import ModalSelectProject from "../../Modal/Project/ProjectSelectModal";
import { storeLocation } from "../../../actions/locations/locations";
import { Button } from "@heroui/button";

export default function CreateLocationsComponent(){
    const router = useNavigate();
    const [pending , setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [isOptionSelected, setIsOptionSelected] = useState(false);
    const [data , setData] = useState({id:"",title:""});
    const [openModal, setOpenModal] = useState(false);
    const [dataProject , setDataProject] = useState({id:"",title:""});
    const [openModalProject, setOpenModalProject] = useState(false);
    async function storeNewLocations(e){
        e.preventDefault();
        const formData = new FormData(e.target);
        formData.append('project_id',dataProject.id);
        formData.append('parent_id',data.id);
        setLoading(true);
        const state = await storeLocation(formData);
        setLoading(false);
        if(state.status === "success"){
            toast.success(state.message);
            router('/locations');
        }else{
            toast.error(state.message);
        }
    }
    const changeTextColor = () => {
        setIsOptionSelected(true);
    };
    return (
      <>
          <ModalSelectLocation setShowModal={(state)=>{
              setOpenModal(state)
          }} setData={""} onSelectedIdsChange={(data)=>{
              setData(data);
          }} showModal={openModal} />

          <ModalSelectProject setShowModal={(state)=>{
              setOpenModalProject(state)
          }} setData={""} onSelectedIdsChange={(data)=>{
              setDataProject(data);
          }} showModal={openModalProject} />
          <DashboardLayout>
              <div className="flex flex-col gap-9">
                  <form onSubmit={storeNewLocations}>
                      <div
                        className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
                          <div className="border-b border-stroke px-6 py-4 dark:border-strokedark">
                              <h3 className="font-medium text-black dark:text-white">
                                  ثبت محل استقرار
                              </h3>
                          </div>
                          <div className="flex flex-col gap-5 p-6">
                              <div className="flex flex-wrap gap-5">
                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          عنوان
                                      </label>
                                      <input
                                        type="text"
                                        name='name'
                                        placeholder="..."
                                        className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                      />

                                  </div>
                                  <div className={"flex-1"}>
                                      <label className="block text-sm font-medium text-gray-700 mb-2">انتخاب والد</label>
                                      <div onClick={()=>{
                                          setOpenModal(true);
                                      }} className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring focus:ring-blue-300">
                                          {data['title'] !== '' ? data['title'] : ' -- '}
                                      </div>
                                  </div>
                                  <div className={"flex-1"}>
                                      <label className="block text-sm font-medium text-gray-700 mb-2">انتخاب پروژه</label>
                                      <div onClick={()=>{
                                          setOpenModalProject(true);
                                      }} className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring focus:ring-blue-300">
                                          {dataProject['title'] !== '' ? dataProject['title'] : ' -- '}
                                      </div>
                                  </div>
                              </div>

                              <div className={"flex mt-10 w-1/5"}>
                                  <Button isLoading={pending} type={"submit"} variant="gradient"
                                          className="!bg-blue-500 !py-5 hover:bg-blue-600 text-white w-full">
                                      ایجاد
                                  </Button>
                              </div>
                          </div>
                      </div>
                  </form>
              </div>
          </DashboardLayout>
      </>
    );
}